const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the add Location component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Categories} Categories injected to gain access to the Categories resource
 */
app.directive('addLocation', ['Application', 'Categories', function (Application, Categories) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        content: '='
      },
      template: require('../../../templates/directives/cms/add-location.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.getError = Application.notifications.getError;
        self.getSuccess = Application.notifications.getSuccess;

        self.initialize = function() {
          Categories.find({
            fields: 'name,location',
            location: true
          }).$promise
          .then(function(locations) {
            self.options = [];
            for (var i = 0; i < locations.length; i++) {
              self.options.push({
                name: locations[i].name,
                value: locations[i]._id
              });
            }
          });
        };
        self.initialize();
      }],
      controllerAs: 'addLocation'
    };
  }]);
